/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Report family — selects the valid resolvers/templates.
 */
export var ReportType;
(function (ReportType) {
    ReportType["STRATEGY"] = "strategy";
    ReportType["NETWORK"] = "network";
    ReportType["ZONE_INSIGHTS"] = "zone_insights";
})(ReportType || (ReportType = {}));
